import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ctaData } from "@/mocks/home";

export default function CtaSection() {
  const { t } = useTranslation("home");

  return (
    <section className="w-full bg-brandgreen py-12 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          <div className="w-full md:w-auto flex justify-center">
            <img
              src={ctaData.image}
              alt="Customer service"
              className="w-48 md:w-56 h-48 md:h-56 object-cover rounded-full"
            />
          </div>
          <div className="text-center md:text-left max-w-lg">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 uppercase tracking-wide">
              {t("cta.title")}
            </h3>
            <p className="text-sm md:text-base text-white/90 leading-relaxed mb-6">
              {t("cta.description")}
            </p>
            <Link
              to={ctaData.buttonLink}
              className="inline-flex items-center gap-2 bg-white text-brandgreen font-semibold px-6 py-3 rounded-md hover:bg-surface transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-chat-3-line" />
              </span>
              {t("cta.button")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}